export default {
  methods: {
    setMeta: function (_title, _description) {
      const _sitename = '神谷智次郎ポートフォリオ';
      const _url = location.href;
      // タイトル・OGPタイトルの設定
      if (this.$store.state.isHomePage) {
        // トップページのときはそのままタイトルを入れる
        document.title = _title;
        document
          .querySelector('meta[property="og:title"]')
          .setAttribute('content', _title);
      } else {
        // それ以外のときは、suffixとしてsitenameを入れる
        document.title = _title + '｜' + _sitename;
        document
          .querySelector('meta[property="og:title"]')
          .setAttribute('content', _title + '｜' + _sitename);
      }
      // description・OGP descriptionの設定
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', _description);
      document
        .querySelector('meta[property="og:description"]')
        .setAttribute('content', _description);
      // OGPの設定
      document
        .querySelector('meta[property="og:site_name"]')
        .setAttribute('content', _sitename);
      document
        .querySelector('meta[property="og:url"]')
        .setAttribute('content', _url);
    }
  }
}
